"use strict";

var _moment = _interopRequireDefault(require("moment"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

module.exports = /*#__PURE__*/function () {
  function agendaDefaultDate(tz) {
    var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, agendaDefaultDate);

    this.timezone = tz;
    this.currentDate = currentDate;
  }

  _createClass(agendaDefaultDate, [{
    key: "getDefaultAgendaDate",
    value: function getDefaultAgendaDate(startDate, endDate) {
      var _this = this;

      var defaultDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var days = this.getDaysList(startDate, endDate),
          today = this.getStartOfDay(this.currentDate),
          defaultDate = parseInt(defaultDay) >= 0 ? this.getStartOfDay(days[defaultDay]) : 0;
      startDate = this.getStartOfDay(startDate);
      endDate = this.getStartOfDay(endDate);

      var newDefaultDate = function () {
        var isEventStarted = _this.isSameOrAfter(today, startDate),
            isEventEnded = today.isAfter(endDate),
            isEventContinued = _this.isBetween(today, startDate, endDate);

        if (isEventContinued) {
          return today;
        }

        if (defaultDate) {
          var isDefaultDateInEventDates = _this.isBetween(defaultDate, startDate, endDate);

          if (!isDefaultDateInEventDates) {
            return startDate;
          }
        }

        if (!isEventContinued) {
          if (!isEventStarted && !defaultDate) {
            return startDate;
          }

          if (!isEventStarted && defaultDate) {
            return defaultDate;
          }

          if (isEventEnded && defaultDate) {
            return defaultDate;
          }

          if (isEventEnded && !defaultDate) {
            return startDate;
          }
        }

        return startDate;
      }();

      newDefaultDate = Object.keys(days).find(function (day) {
        return newDefaultDate.isSame(days[day], 'days');
      });
      return parseInt(newDefaultDate) || 0;
    }
  }, {
    key: "getDaysList",
    value: function getDaysList(startDate, endDate) {
      startDate = this.getStartOfDay(startDate);
      endDate = this.getStartOfDay(endDate);
      var days = [];

      for (var dayNum = 0; this.isSameOrBefore(startDate, endDate); startDate.add(1, 'days'), dayNum++) {
        days[dayNum] = startDate.valueOf();
      }

      return days;
    }
  }, {
    key: "getDaysObject",
    value: function getDaysObject(startDate, endDate, defaultDay) {
      var dates = [];
      defaultDay = this.getDefaultAgendaDate.apply(this, arguments);
      var currDate = this.getStartOfDay(startDate),
          end = this.getStartOfDay(endDate);

      for (var daysCount = 0; this.isSameOrBefore(currDate, end); currDate.add(1, 'days'), daysCount++) {
        dates.push({
          timestamp: currDate.valueOf(),
          text: currDate.format('dddd, MMMM, D'),
          selected: daysCount === defaultDay,
          index: daysCount
        });
      }

      return dates;
    }
  }, {
    key: "isEventContinued",
    value: function isEventContinued(startDate, endDate) {
      var today = this.getStartOfDay(),
          startDay = this.getStartOfDay(startDate),
          endDay = this.getStartOfDay(endDate);
      return this.isBetween(today, startDay, endDay);
    }
  }, {
    key: "getDayIndex",
    value: function getDayIndex(reqIndex, startDay, endDate, defaultDay) {
      var index = parseInt(reqIndex, 10);
      index = index || index === 0 ? index : this.getDefaultAgendaDate(startDay, endDate, defaultDay);
      return parseInt(index, 10);
    }
  }, {
    key: "getStartOfDay",
    value: function getStartOfDay(date) {
      return date ? _momentTimezone.default.tz(date, this.timezone).startOf('day') : _momentTimezone.default.tz(this.timezone).startOf('day');
    }
  }, {
    key: "isSameOrBefore",
    value: function isSameOrBefore(startDate, endDate) {
      return startDate.isSame(endDate, 'd') || startDate.isBefore(endDate, 'd');
    }
  }, {
    key: "isSameOrAfter",
    value: function isSameOrAfter(startDate, endDate) {
      return startDate.isSame(endDate) || startDate.isAfter(endDate);
    }
  }, {
    key: "isBetween",
    value: function isBetween(currDate, startDate, endDate) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '[]';
      var START_DATE_INCLUSIVE = '[',
          END_DATE_INCLUSIVE = ']',
          START_DATE_OPTION = 0,
          END_DATE_OPTION = 1,
          greaterThanMin = options[START_DATE_OPTION] === START_DATE_INCLUSIVE ? this.isSameOrAfter(currDate, startDate) : currDate.isAfter(startDate),
          lowerThanMax = options[END_DATE_OPTION] === END_DATE_INCLUSIVE ? this.isSameOrBefore(currDate, endDate) : currDate.isBefore(endDate);
      return greaterThanMin && lowerThanMax;
    }
  }]);

  return agendaDefaultDate;
}();